import React, { useState, useEffect, useContext } from 'react'
import CustomLabel from '../../components/common/customLabel'
import CustomInput from '../../components/common/customInput'
import useSetTitlePage from '../../hooks/useSetTitlePage'
import colors from '../../../config/colors'
import { Grid, Divider, FormControl, Select, MenuItem, Button, Box, Typography, Alert, Chip } from '@mui/material'
import CustomTable from '../../components/common/customTable'
import { labelTitlePrestador, inputRegistro } from '../../global/styles'
import * as apiService from '../../../api/index'
import UseIconHooks from '../../hooks/useIconHooks'
import DialogCoberturaProcedimiento from '../../components/consulta/cobertura/dialogCoberturaProcedimiento'
import { useSnackbar } from 'notistack'
import ModalLoading from '../../components/common/modalLoading'
import { ConfigurationContext } from '../../context/configurationContext'
import { useSelector } from 'react-redux'
import VerDetallesPrestadores from '../../components/prestador/verDetallesPrestadores'
import { PrestadorContext } from '../../context/prestadorContext'
import { createIdTag } from '../../utils/helpers'

const Cobertura = () => {
	const [gruposPdss, setGruposPdss] = useState([])
	const [regimenField, setRegimenField] = useState(0)
	const [regimenes, setRegimenes] = useState([])
	const [grupoField, setGrupoField] = useState('')
	const [subGruposPdss, setSubGruposPdss] = useState([])
	const [subGrupoField, setSubGrupoField] = useState('')
	const [disableSubGrupoField, setDisableSubGrupoField] = useState(true)
	const [procedimientos, setProcedimientos] = useState()
	const [nombreField, setNombreField] = useState('')
	const handlerNombreField = ({ target }) => setNombreField(target.value)
	const [regimenesDisponibles, setRegimenesDisponible] = useState([]);
	const [openCobertura, setOpenCobertura] = useState(false)
	const [coberturaActual, setCoberturaActual] = useState({
		codigoSimon: '',
		codigoCup: '',
		procedimientoDescripcion: '',
		codigoGrupo: '',
		grupo: '',
		codigoSubGrupo: '',
		subGrupo: '',
		valorTarifario: 0,
		coberturaPdss: 0,
		coberturaTotal: 0,
		montoCopago: 0
	})
	const { handlerIsLoginPage, getAlertaPersonalizada, mostrarMensajeAlerta } = useContext(ConfigurationContext)
	const [loading, setLoading] = useState(false)
	const { enqueueSnackbar, closeSnackbar } = useSnackbar()
	const infoAfiliado = useSelector((state) => state.afiliado.infoAfiliado)
	const isDark = infoAfiliado.isUltra && infoAfiliado.ultraDarkMode
	const isUltraLight = infoAfiliado.isUltra && !infoAfiliado.ultraDarkMode
	const [planField] = useState()
	const [listaPrestadorCoberturaPDSS, setListaPrestadorCoberturaPDSS] = useState([])
	const [totalRegistrosDisponibles, setTotalRegistrosDisponibles] = useState(0)
	const { idPrestador,setIdPrestador} = useContext(PrestadorContext);

	const handlerCloseCobertura = () => {
		setOpenCobertura(false)
	}

	useEffect(() => {
		handlerIsLoginPage(false)
		obtenerGrupoPdss()
		obtenerRegimenes()
		obtenerRegimenAfiliadoLogin()
		getAlertaPersonalizada()
		buscarPrestadoresCobertura()

		return () => {
			setGruposPdss([])
			setGrupoField('')
			setSubGruposPdss([])
			setSubGrupoField('')
			setDisableSubGrupoField(true)
			setProcedimientos([])
			setOpenCobertura(false)
			setLoading(false)
			setNombreField('')
		}
	}, [])

	useEffect(() => {
		if (grupoField === '' || grupoField === null) {
			setDisableSubGrupoField(true)
			setSubGruposPdss([])
			setSubGrupoField('')
		} else {
			apiService.drops
				.getAllSubGruposPdss(grupoField)
				.then((response) => {
					setDisableSubGrupoField(false)
					setSubGruposPdss(response.data.result)
				})
				.catch((err) => console.log(err))
		}
	}, [grupoField])

	const obtenerRegimenAfiliadoLogin = () => {

		const Regimen = infoAfiliado.regimen
		let regimen = 0

		switch (Regimen) {
			case "SUBSIDIADO":
				regimen = 1;
			  break;	
			case "CONTRIBUTIVO":
				regimen = 2
				break;
			case "SeNaSa LARIMAR":
				regimen = 4
				break;
			case "VOLUNTARIOS COLECTIVOS":
				regimen = 5
				break;
			case "PENSIONADOS Y JUBILADOS (342-09)":
				regimen = 6
				break;
			case "PLAN ESPECIAL DE SALUD PENSIONADOS":
				regimen = 10
				break;
		}

		setRegimenField(regimen)
		
	}

	const obtenerGrupoPdss = () => {
		apiService.drops
			.getAllGruposPdss()
			.then((response) => {
				response.data.result.unshift({ codigo: '', descripcion: 'Ninguno' })
				setGruposPdss(response.data.result)
			})
			.catch((err) => console.log(err))
	}

	const obtenerRegimenes = () => {
		apiService.drops
			.getAllRegimenes()
			.then((response) => {
				setRegimenes(response.data.result || [])
			})
			.catch((err) => console.log(err))
	}
	
	const obtenerProcedimientos = (pagina=1, registroPorPagina=10) => {
		// Búsqueda pública: no requiere parámetros mínimos. Si el usuario no
		// selecciona criterios se devuelven todos los resultados paginados.
		obtenerCoberturas(pagina, registroPorPagina)
	}

	const busquedaProcedimientos = () => {
		if (!regimenField) {
			mostrarMensaje('Debe seleccionar un régimen para realizar la consulta.', 'warning')
			return
		}
		obtenerProcedimientos()
	}

	const obtenerCoberturas = (pagina, registroPorPagina) => {
		setLoading(true);
	
		const nombre = nombreField ?? '';
		const grupo = grupoField ? grupoField : 0;
		const subGrupo = subGrupoField.trimEnd() ?? '';

		apiService.cobertura
			.getProcedimientos(grupo, subGrupo, nombre, idPrestador || 0, pagina, registroPorPagina, regimenField, planField)
			.then((response) => {
				setTotalRegistrosDisponibles(response.data.result.cantidadRegistros);
				const result = response.data.result.data || response.data.result;
				setProcedimientos(result);
				setLoading(false);
	
				if (result.length === 0) {
					mostrarMensaje(mostrarMensajeAlerta("cobertura-consulta-nofound"), 'warning');
				}
			})
			.catch((err) => {
				console.error(err);
				mostrarMensaje('Ha ocurrido un error, favor de intentar mas tarde', 'error');
				setLoading(false);
			});
	};
	
	const agregarRegimenesDisponibles = (value) => {
		const regimenes = []

		if (value.contributivo === 1)
			regimenes.push("Contributivo")

		if (value.subsidiado === 1)
			regimenes.push("Subsidiado")
		
		if (value.complementario === 1)
			regimenes.push("Complementario")
		
			 
		setRegimenesDisponible(regimenes)

	}

	const TitleCobertura = (
		<>
			<CustomLabel style={{ ...labelTitlePrestador }}>Consulta de Coberturas</CustomLabel>
			<Divider />
			<br />
			<br />
		</>
	)

	useSetTitlePage(TitleCobertura)

	const columnas = [
		{
			id: 'descripcion',
			label: 'Procedimiento',
			minWidth: 170
		}
	]

	const acciones = [
		{
			icono: UseIconHooks('visibility', {
				style: { color: colors.primary }
			}),
			metodo: (value) => {
			
				if (!regimenField) {
					mostrarMensaje('Debe seleccionar un régimen para ver el detalle.','warning')
					return
				}
				setLoading(true)
				agregarRegimenesDisponibles(value)

				apiService.cobertura
					.postCoberturaProcedimiento({
						regimen: regimenField,
						codProcedimiento: value.codigo,
						grupo: grupoField ? grupoField : value.grupo,
						subGrupo: subGrupoField ? subGrupoField : value.subGrupo
					})
					.then((response) => {
						if (!response.data.result || response.data.result.length === 0) {
							mostrarMensaje('No encontró la cobertura del procedimiento.','warning' )
							return
						}
						setCoberturaActual(response.data.result)
						setOpenCobertura(true)
					})
					.catch((err) => console.log(err))
					.finally(() => {
						setLoading(false)
					})
			},
			label: 'Ver detalles',
			
		},
		{
			icono: UseIconHooks('localHospital', {
				style: { color: colors.primary }
			}),
			metodo: (value) => verPrestadores(value.codigo, 1, 10),
			label: 'Ver prestadores',
			
		}
	]

	const verPrestadores = async(_codigoProcedimiento, _numeroPagina, _registroPorPagina) => {
		setLoading(true)
		const regimenSeleccionado = regimenes.find(r => r.codigo === regimenField)
		await apiService.prestador.getPrestadoresPorCatalogoPDSS(_codigoProcedimiento, _numeroPagina, _registroPorPagina, regimenField || 0)
		.then(res => {
			if(!res.data.result.data){
				mostrarMensaje("No se han encontrado prestadores", "warning")
			}else{
				setListaPrestadorCoberturaPDSS({
					...res.data,
					codigoProcedimiento: _codigoProcedimiento,
					idRegimen: regimenField || 0,
					descripcionRegimen: regimenSeleccionado ? regimenSeleccionado.descripcion : ''
				});
				
			}
		})
		.catch(err => {
			mostrarMensaje("Ha ocurrido un error, favor intentar nueva vez .","error")
			console.error(err)
		})
		.finally(()=> setLoading(false))
	}

	const mostrarMensaje = (nota, tipo) => {
		enqueueSnackbar(nota, {
		  variant: tipo,
		  action: (key) => (
			<Button style={{ color: 'white', fontWeight: 'bold' }} onClick={() => closeSnackbar(key)}>
			  X
			</Button>
		  ),
		});
	};

	const handlerPage = (pagina, registroPorPagina) =>{
		
		obtenerProcedimientos(pagina, registroPorPagina)
	}

	const buscarPrestadoresCobertura = () => {
		if(idPrestador)
		{
			obtenerCoberturas()
			setIdPrestador(0)
		}
	}

	return (
		<>
			<Box sx={{ borderRadius: 2, overflow: 'hidden', boxShadow: isDark ? '0 4px 24px rgba(0,0,0,0.5)' : '0 2px 10px rgba(0,0,0,0.12)', mb: 3, border: isDark ? `1px solid ${colors.ultraAccentBorder}` : isUltraLight ? `1px solid ${colors.ulBorder}` : undefined }}>
				<Box sx={{ backgroundColor: isDark ? colors.ultraAccent : isUltraLight ? colors.ulCardDark : colors.primary, py: 2, textAlign: 'center' }}>
					<Typography style={{ color: 'white', fontFamily: 'Montserrat', fontWeight: 'bold', fontSize: 18, letterSpacing: 0.5 }}>
						Consulta de Coberturas
					</Typography>
				</Box>
				<Box sx={{ backgroundColor: isDark ? colors.ultraMid : 'white', px: 4, py: 3 }}>
					<Grid container spacing={2} alignItems='flex-end'>
						<Grid item md={3} xs={12}>
							<Typography style={{ fontFamily: 'Montserrat', fontSize: 11, fontWeight: 700, color: isDark ? colors.ultraAccentLight : colors.gray, letterSpacing: 1, textTransform: 'uppercase', marginBottom: 6 }}>
								Régimen
							</Typography>
							<FormControl fullWidth>
								<Select
									labelId='regimen'
									id='select-regimen'
									value={regimenField}
									displayEmpty
									onChange={(event) => setRegimenField(event.target.value)}
									style={{ fontFamily: 'Montserrat', backgroundColor: isDark ? colors.ultraSurface : 'white', color: isDark ? colors.ultraSilver : undefined, height: 48, borderRadius: 8 }}
									sx={isDark ? { '& .MuiOutlinedInput-notchedOutline': { borderColor: colors.ultraBorder }, '& .MuiSvgIcon-root': { color: colors.ultraSilver } } : {}}
								>
									<MenuItem value={0}>--Todos--</MenuItem>
									{regimenes.map((item) => (
										<MenuItem id={createIdTag('select-regimen', item.descripcion)} key={item.codigo} value={item.codigo}>
											{item.descripcion}
										</MenuItem>
									))}
								</Select>
							</FormControl>
						</Grid>
						<Grid item md={3} xs={12}>
							<Typography style={{ fontFamily: 'Montserrat', fontSize: 11, fontWeight: 700, color: isDark ? colors.ultraAccentLight : colors.gray, letterSpacing: 1, textTransform: 'uppercase', marginBottom: 6 }}>
								Grupo PDSS
							</Typography>
							<FormControl fullWidth>
								<Select
									labelId='grupos'
									value={grupoField}
									displayEmpty
									onChange={(event) => setGrupoField(event.target.value)}
									style={{ fontFamily: 'Montserrat', backgroundColor: isDark ? colors.ultraSurface : 'white', color: isDark ? colors.ultraSilver : undefined, height: 48, borderRadius: 8 }}
									sx={isDark ? { '& .MuiOutlinedInput-notchedOutline': { borderColor: colors.ultraBorder }, '& .MuiSvgIcon-root': { color: colors.ultraSilver } } : {}}
								>
									<MenuItem value=''>--Todos--</MenuItem>
									{gruposPdss.filter(g => g.codigo !== '').map((item) => (
										<MenuItem id={createIdTag('select', item.descripcion)} key={item.codigo} value={item.codigo}>
											{item.descripcion}
										</MenuItem>
									))}
								</Select>
							</FormControl>
						</Grid>
						<Grid item md={3} xs={12}>
							<Typography style={{ fontFamily: 'Montserrat', fontSize: 11, fontWeight: 700, color: isDark ? colors.ultraAccentLight : colors.gray, letterSpacing: 1, textTransform: 'uppercase', marginBottom: 6 }}>
								Subgrupo PDSS
							</Typography>
							<FormControl fullWidth>
								<Select
									labelId='subGrupos'
									value={subGrupoField}
									displayEmpty
									onChange={(event) => setSubGrupoField(event.target.value)}
									disabled={disableSubGrupoField}
									style={{ fontFamily: 'Montserrat', backgroundColor: isDark ? (disableSubGrupoField ? 'rgba(37,37,37,0.5)' : colors.ultraSurface) : (disableSubGrupoField ? '#f5f5f5' : 'white'), color: isDark ? colors.ultraSilver : undefined, height: 48, borderRadius: 8 }}
									sx={isDark ? { '& .MuiOutlinedInput-notchedOutline': { borderColor: colors.ultraBorder }, '& .MuiSvgIcon-root': { color: colors.ultraSilver } } : {}}
								>
									<MenuItem value=''>--Todos--</MenuItem>
									{subGruposPdss.map((item) => (
										<MenuItem id={createIdTag('select', item.descripcion)} key={item.codigo} value={item.codigo}>
											{item.descripcion}
										</MenuItem>
									))}
								</Select>
							</FormControl>
						</Grid>
						<Grid item md={3} xs={12}>
							<Typography style={{ fontFamily: 'Montserrat', fontSize: 11, fontWeight: 700, color: isDark ? colors.ultraAccentLight : colors.gray, letterSpacing: 1, textTransform: 'uppercase', marginBottom: 6 }}>
								Nombre
							</Typography>
							<CustomInput
								id="input-nombre"
								style={{ ...inputRegistro, backgroundColor: isDark ? colors.ultraSurface : 'white', color: isDark ? colors.ultraSilver : undefined, borderColor: isDark ? colors.ultraBorder : undefined, height: 48, borderRadius: 8 }}
								placeholder='Buscar por nombre...'
								value={nombreField}
								onChange={handlerNombreField}
							/>
						</Grid>
						<Grid item md={3} xs={12}>
							<Button
								id="btn-buscar"
								fullWidth
								variant='contained'
								startIcon={UseIconHooks('search', { style: { color: 'white' } })}
								style={{ backgroundColor: isDark ? colors.ultraAccent : isUltraLight ? colors.ulCardDark : colors.primary, color: 'white', fontFamily: 'Montserrat', fontWeight: 'bold', textTransform: 'initial', height: 48, borderRadius: 8, fontSize: 15 }}
								onClick={busquedaProcedimientos}
							>
								Consultar
							</Button>
						</Grid>
					</Grid>
				</Box>
			</Box>
			<Grid container spacing={2}>
				{/* {regimenField && procedimientos && procedimientos.length > 0 ? (
					<Grid item xs={12} marginTop={3}>
						<Alert
							severity="info"
							variant="outlined"
							sx={{
								borderRadius: 2,
								borderColor: colors.primary,
								color: colors.primary,
								fontFamily: 'Montserrat',
								'& .MuiAlert-icon': { color: colors.primary }
							}}
						>
							Resultados filtrados por régimen:&nbsp;
							<Chip
								size="small"
								label={(regimenes.find(r => r.codigo === regimenField) || {}).descripcion || regimenField}
								sx={{ backgroundColor: colors.primary, color: 'white', fontWeight: 'bold', ml: 0.5 }}
							/>
						</Alert>
					</Grid>
				) : null} */}
				<Grid item xs={12} marginTop={regimenField && procedimientos && procedimientos.length > 0 ? 1 : 3}>
					<CustomTable columns={columnas} acciones={acciones} rows={procedimientos} handlerPage={handlerPage} totalDisponibles={totalRegistrosDisponibles}/>
				</Grid>
			</Grid>
			<ModalLoading open={loading} onCloseHandler={() => setLoading(false)} />
			<DialogCoberturaProcedimiento open={openCobertura} handlerCloseModal={handlerCloseCobertura} cobertura={coberturaActual} regimenesDisponible={regimenesDisponibles} />
			<VerDetallesPrestadores lista={listaPrestadorCoberturaPDSS} titulo={"Cobertura PDSS"} verMas={verPrestadores}/>
		</>
	)
}

export default Cobertura
